/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AnalyticsOverview,
  ModeratorsAnalyticsOverviewRetrieveParams
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Match funnel + D1-7 tiered success + cycle times + moderator time log histogram + manual-deals block, over `[from, to]`. Omit the dates for a trailing 90-day window. Manual deals and legacy 'Moderator-assigned contract' placeholders are excluded from the match funnel; manual deals are reported separately. 400 `{"error": ...}` on an unknown corridor / source / out-of-order dates.
 * @summary Funnel analytics overview (moderator)
 */
export const moderatorsAnalyticsOverviewRetrieve = (
    params?: ModeratorsAnalyticsOverviewRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AnalyticsOverview>(
      {url: `/api/v1/moderators/analytics/overview/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsAnalyticsOverviewRetrieveQueryKey = (params?: ModeratorsAnalyticsOverviewRetrieveParams,) => {
    return [`/api/v1/moderators/analytics/overview/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsAnalyticsOverviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>, TError = void>(params?: ModeratorsAnalyticsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsAnalyticsOverviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>> = ({ signal }) => moderatorsAnalyticsOverviewRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsAnalyticsOverviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>>
export type ModeratorsAnalyticsOverviewRetrieveQueryError = void

/**
 * @summary Funnel analytics overview (moderator)
 */
export const useModeratorsAnalyticsOverviewRetrieve = <TData = Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>, TError = void>(
 params?: ModeratorsAnalyticsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsAnalyticsOverviewRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsAnalyticsOverviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



